export default __webpack_public_path__ + "static/media/icon__7.3ddc7743.svg";